import { ItemCard } from '../../components/ItemCard';
import type { SpaItemCardProps } from './SpaItemCard.types';

const defaultFormatGuests = (min: number, max: number) => {
  if (min === max) return `${min} ${min === 1 ? 'guest' : 'guests'}`;
  return `${min}-${max} guests`;
};

function buildMeta(
  duration: string | undefined,
  minGuests: number | undefined,
  maxGuests: number | undefined,
  formatGuests: (min: number, max: number) => string
): string {
  const meta: string[] = [];
  if (duration) meta.push(duration);
  if (minGuests && minGuests > 0 && maxGuests && maxGuests > 0) {
    meta.push(formatGuests(minGuests, maxGuests));
  }
  return meta.join(' \u00B7 ');
}

export function SpaItemCard({
  id,
  name,
  imageUrl,
  imageAspectRatio,
  price,
  discount,
  duration,
  minGuests,
  maxGuests,
  unavailable,
  promotionName,
  fromPriceLabel = 'From',
  soldOutLabel = 'Sold out',
  editSearchLabel,
  onEditSearch,
  noImageLabel = 'No image',
  formatGuests = defaultFormatGuests,
  onSelect,
}: SpaItemCardProps) {
  const meta = buildMeta(duration, minGuests, maxGuests, formatGuests);

  return (
    <ItemCard
      image={{ src: imageUrl, alt: name, placeholderLabel: noImageLabel }}
      imageAspectRatio={imageAspectRatio}
      title={name}
      meta={meta || undefined}
      unavailableLabel={unavailable ? soldOutLabel : undefined}
      editSearchLabel={editSearchLabel}
      onEditSearch={onEditSearch}
      imageBadge={promotionName || undefined}
      price={
        !unavailable && price
          ? {
              amount: price.amount,
              currencyCode: price.currencyCode,
              label: fromPriceLabel,
              discount,
            }
          : undefined
      }
      unavailable={unavailable}
      ariaLabel={name}
      onSelect={() => onSelect(id)}
    />
  );
}
